/* eslint-disable no-param-reassign */
import type { WritableBitmap } from "./types.ts";
import { bitmapChannels } from "./types.ts";

function ensureBitmapOpaque(image: WritableBitmap) {
	const total = image.width * image.height * bitmapChannels;
	for (let i = 3; i < total; i += bitmapChannels) {
		image.data[i] = 0xff;
	}
}

export default ensureBitmapOpaque;
